import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import RenderPhoneInput from 'react-phone-input-2';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import MessageIcon from '@material-ui/icons/Message';
import withSizes from 'react-sizes';
import SmartPhoneIcon from '@material-ui/icons/Smartphone';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import ReactCodeInput from 'react-verification-code-input';
import OtpInput from 'react-otp-input';

import axios from 'axios';
import PropTypes from 'prop-types';

const styles = theme => ({
    root: {
        // marginLeft: theme.spacing.unit * 1,
        width: 500,
        height: 300,
        // marginTop:'80px'
    },
    card: {
        width: '100%',
        height: '100%',
    },
    button:{
        width: '250px',
        margin: '0px'
    },
    loading:{
        alignItems: 'center',
        justifyContent: 'center',
    },
    message: {
        margin: 'opx',
        width: '300px',
        fontSize:'bold'
    },
    textField:{
        width: '250px',
        //marginLeft: theme.spacing.unit,
        //marginRight: theme.spacing.unit,
    },
    bInput: {
      background: "rgba(255, 255, 255, 0.5)",
      outline: "0",
      color: "#99192D",
      wordWrap: "break-word",
      wordBreak: "break-word",
      border: "2px solid #99192D",
      textTransform: 'none',
      paddingTop: "10px",
      paddingBottom: "10px",
      borderRadius: "25px",
    //   height: "30px",
      marginLeft: "3px",
      marginRight: "3px",
      boxSizing: "border-box",
      fontSize: "16px",
      "&:hover": {
          color: "white",
        },
    },
    
});

class CodeVerify extends Component {
    state = {
        code: null,
        timeOver: false,
        time: 120,
        windowHeight:0,
        windowWidth:0
    };

    handleResize = () => {
        this.setState({
          windowHeight: window.innerHeight,
          windowWidth: window.innerWidth,
        });
        this.innerWidth = window.innerWidth;
        console.log(
          "Window Size: window.innerHeight: " +
            window.innerHeight +
            " window.innerWidth: " +
            window.innerWidth +
            " div 4: " +
            window.innerWidth / 4
        );
      };

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    componentDidMount(){
        if (this.props.isVerified){
            this.props.getCaseInfo(this.props.caseId);
        }

        this.handleResize();
        window.addEventListener("resize", this.handleResize);

        setInterval(() => {
            window.document.querySelectorAll('input[type=tel]').forEach((e) => {
                e.style.borderRight = 'none';
                e.style.borderLeft = 'none';
                e.style.borderTop = 'none';
                e.style.borderBottom = '2px solid black';
                e.style.borderBottomLeftRadius = '0px';
                e.style.borderBottomRightRadius = '0px';
                e.style.marginRight = '12px';
            })
        }, 300)

        // setTimeout(()=>{
        //     this.setState({
        //         timeOver: true
        //     })
        // },120000)

        // var t = setInterval(()=>{
        //     if (this.state.time <= 0){
        //         clearInterval(t)
        //         this.setState({
        //             timeOver: true
        //         })
        //     }
        //     else{
        //         this.setState({
        //             time: this.state.time-1
        //         })
        //     }
            
        // },1000)

    }

    // handleChange = prop => event => {
    //     console.log('handleChange*: '+JSON.stringify(event.target) )
    //     this.setState({ [prop]: event.target.value });
    // };

    handleChange = vals => {
        // if (vals.length >= 6) {
        //   console.log('complete, ', vals);
        // } else if (vals.length === 0) {
        //   console.log('empty, ', vals);
        // }
        this.setState({ code: vals });
      };

    refreshLoc = ()=>{
        window.location.reload()
    }

    submitHandlerVerify = (event) => {
        console.log('submitHandlerVerify called code: '+this.state.code)
        event.preventDefault();
        this.props.onVerify(localStorage.getItem('token'), this.state.code, this.props.caseId, this.props.userType, this.props.telephone, this.props.handleComplete); 
    };

    render() {
        const { classes, error} = this.props;
        const state = this.state;
        if(this.props.localIsVerified){
            return (
                <div>
                    <CardContent>
                        <Typography gutterButtom variant='subtitle1' component='p' className={classes.message}>
                            <SmartPhoneIcon />
                                {this.props.telephone}
                        </Typography>
                        <div>
                            <VerifiedUserIcon color="action" fontSize='large'/>
                        </div>
                    </CardContent>
                </div>
            )
        }else{
            return (            
                <form onSubmit={this.submitHandlerVerify} className={classes.root} style={{width: !this.props.isDesktop ? '100%' : '100%', textAlign: !this.props.isDesktop ?'center':'center', marginTop: this.props.isDesktop ? '80px' : ''}}>
                    
                        <p style={{fontWeight:'bold'}}>
                            {this.context.t('Please Enter the Verification Code')}
                        </p>

                        <ReactCodeInput
                            fieldWidth={ this.props.isDesktop ? "5%" : "10%"}
                            value={this.state.code}
                            onChange={this.handleChange}
                            disabled={this.state.loginInProgress}
                        />

                        {/* {!this.props.isDesktop && 
                        <OtpInput
                            value={this.state.code}
                            onChange={this.handleChange}
                            numInputs={6}
                            containerStyle={{ justifyContent : 'center' }}
                            inputStyle={{
                                borderTop: "0px",
                                borderLeft: "0px",
                                borderRight: "0px",
                                botderBottom:'2px',
                                outline:'none',
                                fontSize:'30px'
                            }}
                            separator={<span style={{color:'transparent'}}>-</span>}
                        />} */}

                        {/* {!this.props.isDesktop &&
                            <table style={{width:'100%'}}>
                            <tr >
                            <td style={{ fontSize:'small',color:'white'}}>+</td>
                            <td style={{ fontSize:'small',color:'white'}}>+</td>
                            <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}><input></input></td>
                            <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:'white'}}>+</td>
                            <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}><input></input></td>
                            <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:'white'}}>+</td>
                            <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}><input></input></td>
                            <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:'white'}}>+</td>
                            <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}><input></input></td>
                            <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:'white'}}>+</td>
                            <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}><input></input></td>
                            <td style={{ fontSize:'small', marginLeft:'2px', marginRight:'2px',color:'              '}}>+</td>
                            <td style={{borderBottom:'thin solid', fontSize:'xx-large'}}><input></input></td>
                            <td style={{ fontSize:'small',color:'white'}}>+</td>
                            <td style={{ fontSize:'small',color:'white'}}>+</td>
                            </tr>
                        </table>} */}
                        
                        { this.props.isLoading ? 
                            <div className={classes.button}>
                                <CircularProgress size={25} thickness={2} className={classes.loading}/>
                            </div>
                            :
                            this.state.timeOver ? '' : 
                            <Button
                                variant="contained"
                                type="submit"
                                color="primary"
                                disabled={this.state.loginInProgress}
                                className={classes.bInput}
                                style={{marginTop:'30px', textTransform:'capitalize', padding:'12px', wordBreak:'keep-all'}}
                                >
                                {this.context.t('Verify')}
                            </Button>
                        }
                        
                </form>
            );
        }
        
    }
}

const mapStateToProps = (state) => {
    return {
        isLoading: state.verify.loginInProgressVerifyCode,
        error: state.verify.error,
        telephone: state.caseInfo[`${state.caseInfo.userType}_telephone`],
        caseId: state.caseInfo.caseId,
        userType:state.caseInfo.userType,
        localIsVerified:state.verify.isVerified,
        isVerified: state.caseInfo[`${state.caseInfo.userType}_steps_completed`] ? state.caseInfo[`${state.caseInfo.userType}_steps_completed`].verification : null,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onVerify: (uniqueId, code, caseId, userType, telephone, handleComplete) => dispatch(actions.onVerifyCode(uniqueId, code, caseId, userType, telephone, handleComplete)),
        getCaseInfo: (caseId) => dispatch(actions.getCaseInfo(caseId)),
    }
}

const mapSizesToProps = sizes => ({
    isMobile: withSizes.isMobile(sizes),
    isTablet : withSizes.isTablet(sizes),
    isDesktop : withSizes.isDesktop(sizes),
    isGtMobile : withSizes.isGtMobile(sizes),
    isGtTablet : withSizes.isGtTablet(sizes),
    isStTablet : withSizes.isStTablet(sizes),
    isStDesktop : withSizes.isStDesktop(sizes),
    isTabletAndGreater : withSizes.isTabletAndGreater(sizes),
    isTabletAndSmaller : withSizes.isTabletAndSmaller(sizes),

})

CodeVerify.contextTypes = {
    t: PropTypes.func
}

// export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(CodeVerify));
export default connect( mapStateToProps, mapDispatchToProps )(withSizes(mapSizesToProps)(withStyles(styles)(CodeVerify)));